// removed by extract-text-webpack-plugin
module.exports = {"close-button":"style__close-button___d4xYY","close-icon":"style__close-icon___1Lz2B","header":"style__header___OjiFf","title":"style__title___nC2qZ"};


//////////////////
// WEBPACK FOOTER
// ./components/Overlay/style.scss
// module id = 1254
// module chunks = 0